import { render, staticRenderFns } from "./AlertModal.vue?vue&type=template&id=854f89a4&scoped=true"
import script from "./AlertModal.vue?vue&type=script&lang=ts"
export * from "./AlertModal.vue?vue&type=script&lang=ts"
import style0 from "./AlertModal.vue?vue&type=style&index=0&id=854f89a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854f89a4",
  null
  
)

export default component.exports